// extracted by mini-css-extract-plugin
export default {"ColorsPreview":"styles_ColorsPreview__puSRd"};